import React from 'react'
import { Divider, Grid } from '@mui/material'
import * as S from './styles'
import SummaryTableCard from 'src/ui/SummaryTable/SummaryTableCard'
import { PaymentInstructionsDummy, PaymentInstructionsProd } from 'src/common/static'

const BankDetails: React.FC = () => {
  let isTestEnv = true
  if (
    process.env.REACT_APP_API_URL?.includes('staging') ||
    process.env.REACT_APP_API_URL?.includes('sandbox') ||
    process.env.REACT_APP_API_URL?.includes('localhost')
  ) {
    isTestEnv = true
  } else {
    isTestEnv = false
  }
  return (
    <>
      <S.Flex>
        <Grid container direction="row" spacing={2} sx={{ width: '100%' }}>
          <Grid item xs={12} md={6}>
            <SummaryTableCard
              title="Wire Transfer (SWIFT)"
              data={isTestEnv ? PaymentInstructionsDummy[0].swift : PaymentInstructionsProd[0].swift}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <SummaryTableCard
              title="ACH Payment"
              data={isTestEnv ? PaymentInstructionsDummy[0].ach : PaymentInstructionsProd[0].ach}
            />
          </Grid>
        </Grid>
      </S.Flex>
      <Divider />
    </>
  )
}

export default BankDetails
